import { render } from "./PokemonPicture.vue?vue&type=template&id=22131859"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=22131859&scope=true&lang=css"

import exportComponent from "/home/shicksal/Documentos/Trabajos/Vue-js/vue-udemy/04-pokemon-game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__